module.exports = __webpack_public_path__ + "img/Tessellate27.886e1dc3.jpg";